/* eslint-disable camelcase */
import React, { useEffect, useCallback, useRef } from 'react';
import { useSnapshot } from 'valtio';

import { refsStore, poiStore } from '../../managers/globalState';

import Overlay from '../overlays';
import GridList from '../grid_list';
import Filter from '../filter';
import GlobeIcon from '../../../www/assets/images/globe_icon.min.svg';
import EventSVG from '../../../www/assets/images/event-marker.svg';
import '../../../www/assets/css/overlays/poi.css';

import {
	updateYear,
	updateCategory,
	filterPoI
} from '../../helpers/processPoI';
import { POI_CATEGORIES, DYNAMIC_ASSETS_URL } from '../../config/constants';


/**
 * Constant vars
 */
// const API_BASE_URL = window.config.apiUrl ? window.config.apiUrl : 'https://climate.nasa.gov';

const THUMB_WIDTH = 159;
const THUMB_HEIGHT = 102;
const ITEM_PADDING = 30;
const TITLE_TEXT = 'أبرز المعالم';
const BUTTON_TEXT = 'عرض على الكرة الأرضية';

/**
 * ButtonText component
 */
const ButtonText = () => <span>{BUTTON_TEXT}</span>;

/**
 * Individual EventItem component to represent each event in the grid
 */
const PoIItem = props => {
	const { title, external_id, list_image_src, formatted_date, onItemClick } = props;
	let srcUrl = '';
	if(list_image_src.indexOf('/system') == 0){
		srcUrl = 'https://climate.nasa.gov' + list_image_src;
	} else {
		srcUrl = list_image_src;
	}
	const onClick = useCallback(() => {
		onItemClick(external_id);
	}, [onItemClick, external_id]);

	const imgStyle = {
		maxWidth: `${THUMB_WIDTH}px`,
		height: `${THUMB_HEIGHT}px`
	};

	return (
		<div className='poi-item' onClick={onClick}>
			<img className='thumbnail' style={imgStyle} src={srcUrl} alt={title} />
			<span className='poi-date'>{formatted_date}</span>
			<span className='poi-title'>{title}</span>
		</div>
	);
};


/**
 * Poi Overlay component
 */
const PoIOverlay = ({ closeOverlay, isMobile }) => {
	const mainRef = useRef();

	// get the global state
	const { yearIndex, categoryIndex, pois, poi_cats,poiYears } = useSnapshot(poiStore.state);

	// get the get ref.
	const { get } = useSnapshot(refsStore.state);

  let poiCategories = poi_cats.map(v => v[1])
	// onMount, we want to set showOnGlobe to false
	useEffect(() => {
		// then let's set it to false
		poiStore.setGlobalState({ showOnGlobePoI: false });
	}, []);

	// data filtering
	const filteredData = filterPoI(pois,poiYears, yearIndex, categoryIndex);


	// navToEvent callback
	const navToPoI = useCallback(poiId => {
    let _poi = poiId.replace('eo_', '')
		closeOverlay(true);
		const routeManager = get('route');
	  routeManager.goToPoI(_poi);
	}, [closeOverlay, get]);

	// viewOnGlobe callback
	const viewOnGlobe = useCallback(() => {
		// Remove any active video before showing events on globe.
		get('video').setVideoQuery(null);

		// Set the global state.
		const routeManager = get('route');

		if (routeManager?._history?.location?.pathname) {
			const { pathname } = routeManager._history.location;

			if (pathname.indexOf('poi') >= 0 || pathname.indexOf('spacecraft') >= 0) {
				routeManager.navigate('/vitalsign?vitalsign=visible_earth&altid=0&animating=f');
			}
		}

		poiStore.setGlobalState({ showOnGlobePoI: true });

		// Close the overlay.
		closeOverlay(true);
	}, [closeOverlay, get]);
 

	// compose overlay
	return (
		<Overlay type='events' ref={mainRef}>
			<Overlay.Header
				back
				onClose={closeOverlay}
				isMobile={isMobile}
				title={TITLE_TEXT}
				Icon={EventSVG}
			>
				<div className='events-header-content'>
					<div className='events-header-filters'>
						<Filter
							type='dropdown'
							style={{ padding: 10 }}
							allItems={poiYears.map(v => v[1])}
							selectedIndex={yearIndex}
							updateItem={updateYear}
						/>
						<Filter
							type='dropdown'
							style={{ padding: 10 }}
							allItems={poiCategories}
							selectedIndex={categoryIndex}
							updateItem={updateCategory}
						/>
					</div>
					<div className='globe-border'>
						<div className='button' onClick={viewOnGlobe}>
							<GlobeIcon />
							<ButtonText />
						</div>
					</div>
				</div>
			</Overlay.Header>

			<div className='content-mask'>
				{
					filteredData
				&& (
					<GridList
						rowClassName='flex-grid-row'
						minPerRow={2}
						dataList={filteredData}
						itemSize={THUMB_WIDTH + ITEM_PADDING * 2}
						itemPadding={[ITEM_PADDING, ITEM_PADDING]}
						itemComponent={<PoIItem onItemClick={navToPoI} />}
						scrollableRef={mainRef}
					/>
				)
				}
			</div>
		</Overlay>
	);
};


export default PoIOverlay;
